import Handsontable from 'handsontable';
import { GridSettings } from 'handsontable/settings';
import * as R from 'ramda';
import { put, select } from 'redux-saga/effects';

import { actionCreators as alertActionCreators } from 'services/Alert';
import { selectors as commonDataSelectors } from 'services/CommonData';
import { tryCatch } from 'services/ErrorTracking';
import { getFormattedRangeDate, isNotNullable, ValidationError } from 'shared/helpers';
import { HandsontableHeader } from 'shared/view/components';

import * as actionCreators from '../actionCreators';
import * as A from '../../types/actions';

const COLUMN_HEADER_HEIGHT = 23;

export function* downloadMediaplan({ payload: { columnRangeHeaders, getHotInstance, validate } }: A.DownloadMediaplan) {
  yield tryCatch({
    *successed() {
      const ht = getHotInstance();
      if (!ht) {
        throw new Error('hot instance is not initialized');
      }

      const errorMessage = validate?.();
      if (errorMessage) {
        throw new ValidationError(errorMessage);
      }

      const csCampaignInfo: ReturnType<typeof commonDataSelectors.selectCsCampaignInfo> =
        yield select(commonDataSelectors.selectCsCampaignInfo);

      const plugin = ht.getPlugin('exportFile');

      ht.updateSettings({ colHeaders: getColHeaders(ht, columnRangeHeaders), columnHeaderHeight: COLUMN_HEADER_HEIGHT });

      plugin.downloadFile('csv', {
        columnDelimiter: ';',
        columnHeaders: true,
        fileExtension: 'csv',
        filename: getFileName(csCampaignInfo?.mediaplanName),
        mimeType: 'text/csv',
        rowDelimiter: '\r\n',
      });

      ht.updateSettings({ colHeaders: true });

      yield put(actionCreators.downloadMediaplanSuccess());
    },
    *failed(error, message) {
      yield put(actionCreators.downloadMediaplanFail(message));
      yield put(alertActionCreators.openAlert({
        message: error instanceof ValidationError ? message : 'Не удалось скачать файл медиаплана',
        type: 'error',
      }));
    }
  });
}

function getColHeaders(
  ht: Handsontable,
  columnRangeHeaders: HandsontableHeader.models.ColumnRangeHeader[]
): GridSettings['colHeaders'] {
  const colHeaders = R.range(0, ht.countCols()).map((colIndex) => {
    const column = columnRangeHeaders.find(({ columnRange }) =>
      colIndex >= columnRange.start && colIndex <= columnRange.end);
    
    if (!column) {
      return null;
    }

    const headers = [
      column.title,
      column.subTitles?.join('\n'),
      getFormattedRangeDate(column.columnToPeriodMap?.[colIndex]),
    ];

    return headers.filter(Boolean).join('\n\n');
  });

  if (colHeaders.every(isNotNullable)) {
    return colHeaders as string[];
  }

  return true;
}

function getFileName(mediaplanName?: string) {
  const name = mediaplanName ?? 'mediaplan';
  const lastDotIndex = name.lastIndexOf('.');

  if (lastDotIndex === 0 || lastDotIndex === -1) {
    return name;
  }

  return name.substring(0, lastDotIndex);
}
